import React from "react";
import VideoVO from "../../../ts/data/subject/VideoVO";

interface IProps
{
    videoVOs: VideoVO[];
    extraClass?: string;
    videoColumns?: number;
    showTitles?: boolean;

}
const GalleryVideoView = (props: IProps) =>
{
    const videoColumns = props.videoColumns ?? 6;
    return <div className={"row "+(props.extraClass ?? "")}>

        {props.videoVOs.map((videoVO, index) =>
        {

            return <div
                className={"col-12 col-md-" + videoColumns + " mb-3"}
                key={index}
            >
                {!props.showTitles && <>
                    <h2 className="table-heading">{videoVO.name}</h2>
                </>}

                <div className="ratio ratio-16x9 youtube">
                    <iframe aria-label={videoVO.name} id={"ytplayer-user-embed-"+index}  data-engaged="video" data-video-title={videoVO.name} data-video-id={"user-emebd-"+index}  datatype="text/html" width="720" height="405" src={ videoVO.url } frameBorder="0"></iframe>
                </div>
            </div>;
        })}
    </div>
}
export default GalleryVideoView;